import React, { useEffect } from 'react';
import { useHistory } from "react-router-dom";

import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import RecentlySentMessagesTable from './TextMessaging/RecentlySentMessagesTable';
import RepliesTable from './TextMessaging/RepliesTable';

const useStyles = makeStyles(theme => ({
    paper: {
        padding: theme.spacing(3),
    }
}));

const TextMessagingWrapper = () => {
    useEffect(() => {
        document.title = 'Text Messaging';
    }, []);
    const history = useHistory();
    const classes = useStyles();

    const handleStartBulk = () => {
        history.push('/admin/sms/start');
    }

    const handleStartSingle = () => {
        history.push('/admin/sms/single');
    }

    return (
        <Paper square className={classes.paper}>
            <Typography variant="h6">Text Messaging</Typography>
            <Box mt={2} display="flex" gridGap={8}>
                <Button variant="contained" color="primary" onClick={handleStartBulk}>Start a new bulk text message</Button>
                <Button variant="contained" color="default" onClick={handleStartSingle}>Send a text message</Button>
            </Box>
            <Box mt={2}>
                <Typography variant="h6">Recently sent messages</Typography>
            </Box>
            <RecentlySentMessagesTable />
            <Box mt={2}>
                <Typography variant="h6">Recent replies</Typography>
            </Box>
            <RepliesTable />
        </Paper>
    );
}

export default TextMessagingWrapper;
